import { getList } from '@global/api'
import { createObserverHook } from '@global/hooks/queries/createObserverHook'
import { KEY } from '@global/hooks/queries/useListQuery'
import { ListDTOResponse } from '@global/types'
import { toDataRowsFromListColumns } from 'functions'
import { IListTableData } from './listTable/useTableConfiguration'

const useCreateListObserver = createObserverHook<ListDTOResponse, unknown, IListTableData>(KEY)

export const useListObserver = ({ listId }) =>
  useCreateListObserver({
    queryFn: ({ signal }) =>
      getList({
        listId,
        signal,
      }),
    id: listId,
    options: {
      refetchOnWindowFocus: true,
      select: (data: ListDTOResponse): IListTableData => {
        const hasColumns = (data?.list_columns?.length || 0) > 0
        const values = hasColumns ? toDataRowsFromListColumns(data?.list_columns, false) : []

        return {
          ...data,
          columnsByName: data?.list_columns?.map(lc => lc.name) || [],
          values,
        }
      },
    },
  })
